import type { GazePoint } from './avatar-gaze-containment';

/** Time-based damping: gentle pursuit, no overshoot, no jump after a pause. */
export function dampAvatarGaze(
  current: GazePoint,
  target: GazePoint,
  elapsedMs: number
) {
  const elapsed = Number.isFinite(elapsedMs)
    ? Math.max(0, Math.min(48, elapsedMs))
    : 16;
  const amount = 1 - Math.exp(-elapsed / 160);
  const point = {
    x: current.x + (target.x - current.x) * amount,
    y: current.y + (target.y - current.y) * amount,
  };
  const settled = Math.hypot(point.x - target.x, point.y - target.y) < 0.03;
  return { point: settled ? target : point, settled };
}
